require.register("modules/m0x/a03/page-24-il/page-24_il", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page24_il = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page24_il;

  
});

